<template>
  <v-container>
    <v-row>
      <MobileCol>
        <v-card
          class="mx-auto"
        >
          <v-card-title>
            <h2>Grootrivier Radio</h2>
          </v-card-title>
          <v-card-text>
            <audio
            controls
            autoplay="true"
            style="width: 100%"
            src="https://stroom.radiogrootrivier.co.za:8443/rgrstroom">
                    Your browser does not support the
                    <code>audio</code> element.
            </audio>
          </v-card-text>
          <v-card-actions>
            <back-button />
          </v-card-actions>
        </v-card>
      </MobileCol>
    </v-row>
  </v-container>
</template>

<script>
import BackButton from '../components/BackButton.vue';
import MobileCol from '../components/MobileCol.vue';

export default {
  name: 'Radio',
  components: {
    BackButton,
    MobileCol,
  },
};
</script>
